/*
 *
 * Copyright (C) 2022 NetBase Solutions, Inc.
 * 3960 Freedom Circle Suite 201 Santa Clara, CA 95054
 * All rights reserved.
 */

import React from 'react'
import {
  TopicInaccessibleGuard,
  TopicIndexNotReadyGuard,
  TopicLanguageNotSupportedGuard,
  TopicNotSelectedGuard,
  UnexpectedServiceErrorGuard,
  WidgetLoadingGuard
} from 'components/widget/share/guards'
import { WidgetGuard } from 'features/types'
import { CountTypeStrings } from 'enums/CountType'
import AuthorEmptyResultGuard from './AuthorsWidgetsEmptyResultGuard'
import RunSearchEffect from '../RunSearchEffect'

const AuthorsWidgetDataGuards: WidgetGuard<{ countType: CountTypeStrings }> = ({
  widgetId,
  children,
  countType
}) => (
  <TopicNotSelectedGuard widgetId={widgetId}>
    <RunSearchEffect widgetId={widgetId} countType={countType}>
      <WidgetLoadingGuard widgetId={widgetId}>
        <TopicInaccessibleGuard widgetId={widgetId}>
          <UnexpectedServiceErrorGuard widgetId={widgetId}>
            <TopicIndexNotReadyGuard widgetId={widgetId}>
              <TopicLanguageNotSupportedGuard widgetId={widgetId}>
                <AuthorEmptyResultGuard widgetId={widgetId}>{children}</AuthorEmptyResultGuard>
              </TopicLanguageNotSupportedGuard>
            </TopicIndexNotReadyGuard>
          </UnexpectedServiceErrorGuard>
        </TopicInaccessibleGuard>
      </WidgetLoadingGuard>
    </RunSearchEffect>
  </TopicNotSelectedGuard>
)

export default AuthorsWidgetDataGuards
